import { ref, computed } from 'vue';
import { defineStore } from 'pinia';
import networkController from '@/js/networkController.js';
import apiEndpoints from '@/assets/json/apiEndpoints.json';

export const useDocumentsStore = defineStore('documentsStore', () => {
  const itemsList = ref({
    error_code: 0,
    total: 0,
    items: []
  });

  const documentsList = ref();

  const userSignatures = ref({
    error_code: 0,
    total: 0,
    items: []
  });

  const getDocumentsItems = computed(() => userSignatures.value.items);
  const documentVersion = ref(null);

  const getDocumentVersionIsSignature = computed(() => {
    if (documentVersion.value?.is_signature) {
      return documentVersion.value?.is_signature;
    }
    return null;
  });

  async function postDocumentItemsList() {
    return await networkController.post(apiEndpoints.postDocumentItemsList)
      .then(response => {
        itemsList.value = response?.data;
        return response?.data;
      })
      .catch(error => ({ error_code: 500, error_message: 'Server error' }));
  }

  async function documentListAuth() {
    return await networkController.post(apiEndpoints.documentListAuth)
      .then(response => {
        documentsList.value = response?.data;
        return response?.data;
      })
      .catch(error => ({ error_code: 500, error_message: 'Server error' }));
  }

  async function postDocumentUserSignatures() {
    return await networkController.post(apiEndpoints.postDocumentUserSignatures)
      .then(response => {
        userSignatures.value = response?.data;
        return response?.data;
      })
      .catch(error => ({ error_code: 500, error_message: 'Server error' }));
  }

  async function postSignDocument(id = null) {
    return await networkController.post(apiEndpoints.postSignDocument, {
      ...(id && { id })
    })
      .then(response => response?.data)
      .catch(error => ({ error_code: 500, error_message: 'Server error' }));
  }

  async function postGetDocumentVersion(id = null) {
    const resp = await networkController.post(apiEndpoints.postGetDocumentVersion, {
      ...(id && { document_id: id })
    })
      .then(response => response?.data)
      .catch(error => ({ error_code: 500, error_message: 'Server error' }));
    documentVersion.value = resp;
    return resp;
  }

  async function getDownloadDocument(url) {
    await networkController({
      method: 'GET',
      url,
      responseType: 'blob',
      headers: {
        'Content-Disposition': 'attachment',
        'Access-Control-Expose-Headers': 'Content-Disposition',
        'Access-Control-Allow-Headers': 'Content-Disposition'
      }
    }).then(response => {
      const file_reg_exp = /filename="([^"]+)"/;

      const matches = response?.headers?.['content-disposition'].match(file_reg_exp);
      const file_name = (matches) ? matches[1] : 'document';
      console.log('matches', matches);

      const link = document.createElement('a');
      link.href = URL.createObjectURL(response.data);
      link.download = file_name;
      link.click();
      URL.revokeObjectURL(link.href);
    });
  }

  return {
    itemsList,
    userSignatures,
    documentVersion,
    getDocumentsItems,
    getDocumentVersionIsSignature,
    postDocumentItemsList,
    documentListAuth,
    postDocumentUserSignatures,
    postSignDocument,
    postGetDocumentVersion,
    getDownloadDocument
  };
});
